export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 sm:gap-4 border-b border-zinc-300 bg-white px-4 sm:px-8 py-4 sm:py-6">
      <div className="min-w-0">
        <p className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 truncate">{subtitle}</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tighter text-zinc-900 break-words">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{children}</div>}
    </div>
  );
}
